(() => {
  angular
    .module('app.components')
    .factory('DeliveryChartService', DeliveryChartService);

  DeliveryChartService.$inject = ['$filter', 'ChartService'];

  function DeliveryChartService($filter, ChartService) {
    const setupCharts = vm => {
      // Hourly Impressions Chart
      var hourlyImpressionsChartOptions = ChartService.getBaseChartConfig();
      angular.merge(hourlyImpressionsChartOptions, {
        chart: {
          spacingTop: 10,
          type: 'column'
        },
        tooltip: {
          formatter: function () {
            return `
              <h4>
                Hour interval ${String(`00${this.x}`).slice(-2)} - ${String(`00${(this.x + 1) % 24}`).slice(-2)}
              </h4>
              <div class="highcharts-tooltip-outer">
                <table class="highcharts-tooltip-inner">
                  <tr>
                    <td class="td-left">${this.points[0].series.name}:</td>
                    <td class="td-right">${$filter('customNumber')(this.y)}</td>
                  </tr>
                </table>
              </div>`;
          }
        },
        legend: {
          enabled: false
        },
        xAxis: {
          labels: {
            formatter: function () {
              return String(`00${this.value}`).slice(-2);
            }
          },
          tickInterval: 1
        },
        plotOptions: {
          series: {
            minPointLength: 3
          }
        }
      });

      vm.hourlyImpressionsChartConfig = {
        options: hourlyImpressionsChartOptions,
        refreshData: function (source) {
          if (_.isUndefined(source)) return;

          Array.prototype.rotate = function (count) {
            if (count > 0) {
              while (count !== 0) {
                const t = this.pop();
                this.unshift(t);
                count--;
              }
            } else if (count < 0) {
              while (count !== 0) {
                const t = this.shift();
                this.push(t);
                count++;
              }
            }
            return this;
          };

          const sortedImps = _.sortBy(source, 'hour');
          vm.impsUTC = _.pluck(sortedImps, 'count');
          vm.hourlyImpressionsChartConfig.series = [{
            name: 'Impressions',
            data: vm.impsUTC.rotate(vm.timezoneOffset),
            color: hourlyImpressionsChartOptions.colors[0]
          }];
        }
      };

      // Distribution of events across top websites / referrers chart
      const impressionsDistributionChartOptions = ChartService.getBaseChartConfig();
      angular.merge(impressionsDistributionChartOptions, {
        chart: {
          type: 'column',
          spacingTop: 10
        },
        tooltip: {
          formatter: function () {
            return `
              <h4>Website #${(this.x + 1)}</h4>
              <div class="highcharts-tooltip-outer">
                <table class="highcharts-tooltip-inner">
                  <tr>
                    <td class="td-left">${this.points[0].series.name}:</td>
                    <td class="td-right">${$filter('customNumber')(this.y)}</td>
                  </tr>
                </table>
              </div>`;
          }
        },
        legend: {
          enabled: false
        },
        xAxis: {
          labels: {
            formatter: function () {
              return `#${this.value + 1}`;
            }
          }
        },
        plotOptions: {
          series: {
            minPointLength: 3
          }
        }
      });

      vm.impressionsDistributionChartConfig = {
        options: impressionsDistributionChartOptions,
        refreshData: function (referrerImpressions) {
          if (angular.isUndefined(referrerImpressions) || referrerImpressions.length == 0) {
            vm.impressionsDistributionChartConfig.loading = "No data.";
          } else {
            vm.impressionsDistributionChartConfig.loading = false;
          }

          vm.impressionsDistributionChartConfig.series = [{
            name: 'Events',
            data: referrerImpressions || [],
            color: impressionsDistributionChartOptions.colors[0]
          }];
        }
      };

      // Cachebuster Ratio Chart
      var cachebusterRatioChartOptions = ChartService.getBaseChartConfig();
      angular.merge(cachebusterRatioChartOptions, {
          chart: {
            spacingTop: 10
          },
          tooltip: {
            formatter: function () {
              return `
                <h4>${vm.cachebusterDateLabels[this.x]}</h4>
                <div class="highcharts-tooltip-outer">
                  <table class="highcharts-tooltip-inner">
                    <tr>
                      <td class="td-left">${this.points[0].series.name}:</td>
                      <td class="td-right">${$filter('customNumber')(this.y, 2)}%</td>
                    </tr>
                  </table>
                </div>`;
            }
          },
          legend: {
            enabled: false
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              month: '%e. %b',
              year: '%b'
            },
            labels: {
              rotation: -90,
              formatter: function () {
                return vm.cachebusterDateLabels[this.value];
              }
            }
          },
          yAxis: {
            min: 0,
            max: 100
          }
      });

      vm.cachebusterRatioChartConfig = {
        options: cachebusterRatioChartOptions,
        refreshData: function (source) {
          if (angular.isUndefined(source)) return;
          vm.cachebusterDateLabels = _.pluck(_.values(source), 'date');
          vm.cachebusterRatioChartConfig.series = [{
            name: 'Ratio',
            data: _.pluck(_.values(source), 'cachebusterRatio'),
            color: cachebusterRatioChartOptions.colors[0]
          }];
        }
      };
    }

    return {
      setupCharts: vm => setupCharts(vm),
    }
  }
})();
